import Vue from 'vue';

export class TrackingHandler {
  static getModalInfo(modalId) {
    const modalElement = document.getElementById(modalId);

    return {
      element: modalElement,
      goalPath: '/virtual/signup/',
      modalDescription: modalElement.dataset.modalDescription,
      modalHeader: modalElement.dataset.modalHeader,
      modalImage: modalElement.dataset.modalImage,
      modalName: modalElement.dataset.modalName,
      modalTags: modalElement.dataset.modalTags,
      modalTest: modalElement.dataset.modalTest,
      modalTestStartDate: modalElement.dataset.modalTestStartDate,
      modalCampaignName: modalElement.dataset.modalCampaignName,
      pageTitle: document.title,
      pathName: window.location.href.replace(/\?.*/, '').replace(/\#.*/, ''),
      payload: `${ modalElement.dataset.modalName } - Modal ${ modalElement.dataset.modalTest }`,
    };
  }

  static exitModalShown(modalId) {
    if (typeof ga !== 'function') {
      return;
    }

    const modalInfo = TrackingHandler.getModalInfo(modalId);
    TrackingHandler.sendToGA(modalInfo);
  }

  static sendToGA(modalInfo, modalAction='') {
    if (typeof ga !== 'function') {
      return;
    }

    ga('send', {
      'hitType': 'pageview',
      'page': modalInfo.goalPath + modalAction,
      'dimension1': modalInfo.modalName,
      'dimension2': modalInfo.pathName,
      'dimension3': JSON.stringify([
        modalInfo.modalTest,
        modalInfo.modalTestStartDate,
        modalInfo.modalTags,
      ]),
      'dimension4': modalInfo.modalHeader,
      'dimension5': modalInfo.modalDescription,
      'dimension6': modalInfo.modalImage,
      'dimension7': modalInfo.pageTitle,
    });
  }

  static trackEvent(modalId, eventName) {
    if (Vue.prototype.exitModalHandler) {
      Vue.prototype.exitModalHandler.hideModal();
    }

    const modalInfo = TrackingHandler.getModalInfo(modalId);
    TrackingHandler.sendToGA(modalInfo, eventName);
  }
}

export default {
  install: function(Vue, options) {
    Vue.prototype.trackingHandler = TrackingHandler;
  },
};
